<template>
    <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true" :scrollable="true"
        @before-open="beforeOpen" :adaptive="false">
        <div class="modal-container">
            <div class="create-modal-header ">
                <h3>Block Visitor</h3>
                <button @click=close>X</button>
            </div>
            <div class="modal-content">
                <p style="color:black">A blocked user represents a person who is no longer allowed to access the
                    Community. </p>
                <div class="modal-intro-information">
                    <label>Visitor First Name</label>
                    <input ref="title" type="text" placeholder="First Name" class="modal-title" v-model="firstName" />
                    <label>Visitor Last Name</label>
                    <input ref="title" type="text" placeholder="Last Name" class="modal-title" v-model="lastName" />
                    <div class="upload-attachment">
                        <button @click="() => handleUploadAttachments()">
                            <img src="../../assets/Icons/CTicons-02.png" width="23" height="23">
                            <b>Upload Image</b>
                        </button>
                    </div>
                </div>
                <div class="modal-create-data">
                    <div class="modal-create-data-item">
                        <p>Associated Unit*</p>
                        <input ref="resident-name" type="text" placeholder="Resident Name" class="modal-title"
                            v-model="residentUid" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Duration</p>
                        <input ref="visitor-relationship" type="text" placeholder="Visitor Relationship"
                            class="modal-title" v-model="relationship" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Blocked Visitor Vehicle Make</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Blocked Visitor Vehicle Model</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Blocked Visitor Vehicle Color</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Blocked Visitor License Plate #</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Blocked Visitor Email</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Blocked Visitor Phone Number</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Additonal Details</p>
                        <textarea placeholder=""></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button @click="() => alert('Send Key')">Block Visitor</button>
            </div>
        </div>
    </modal>

</template>
<script>

import * as Constants from "../../js/constants.js";

const NAME = Constants.CREATE_BLOCKED_VISITOR_MODAL

export default {
    data() {
        return {
            modalName: NAME,
            firstName: "",
            lastName: "",
            residentUid: "",
            relationship: "",
            businessName: "",
            visitorPhoneNumber: "",
            visitorEmail: "",
            licensePlate: "",
        }
    },
    methods: {
        show() {
            this.$modal.show(NAME);
        },
        close() {
            this.$modal.hide(NAME);
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
        },
    }
}
</script>
<style></style>